if (!customElements.get('affirmations-bar')) {
  class AffirmationsBar extends HTMLElement {
    constructor() {
      super();
      this.slidesArray = this.querySelectorAll('.affirmations-bar__item');
      this.durationArray = [...this.querySelectorAll('[data-duration]')].map((item) => +item.dataset.duration * 1000);
      this.timeoutId = null;
      this.currentIndex = 0;
    }

    connectedCallback() {
      if (this.slidesArray.length > 1) {
        this.toggleSlides();
        window.addEventListener('resize', () => this.toggleSlides());
      }
    }

    toggleSlides() {
      if (window.innerWidth <= 1024) {
        if (!this.timeoutId) {
          this.startAnimation();
        }
      } else {
        this.stopAnimation();
      }
    }

    startAnimation() {
      const showNext = () => {
        this.slidesArray[this.currentIndex].classList.remove('show');
        this.currentIndex = (this.currentIndex + 1) % this.slidesArray.length;
        this.slidesArray[this.currentIndex].classList.add('show');
        this.timeoutId = setTimeout(showNext, this.durationArray[this.currentIndex]);
      };

      this.slidesArray[0].classList.add('show');
      this.timeoutId = setTimeout(showNext, this.durationArray[0]);
    }

    stopAnimation() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.slidesArray.forEach(slide => slide.classList.remove('show'));
      this.currentIndex = 0;
    }
  }

  customElements.define('affirmations-bar', AffirmationsBar);
}
